import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_not_requeired/forgot-password")({
  component: () => <div>Hello /forgot-password!</div>,
});
